// Shared 3D-terrain source config — referenced by every terrain-application path (the 3D toggle, the
// `?dimension=3D` deep link, the basemap-swap preserver, and the layer-panel "terrain" toggle) so they
// can never drift apart.
//
// The DEM is our swissALTI3D Terrain-RGB bake (0.5–2 m DTM, all of Switzerland + a 100 km GLO-30 apron),
// ORTHOMETRIC (LN02 / sea-level). Orthometric matches the swissSURFACE3D LiDAR point cloud's native
// heights and Mapbox's own DEM datum convention, so the point cloud (placed at absolute altitude) rests
// correctly on the precise terrain. `?v8` = the 100 km apron. Beyond CH + 100 km the DEM is nodata
// (renders flat) — acceptable for a Switzerland-focused app. Served direct from the public GCS bucket.
export const THREE_D_TERRAIN_SOURCE = 'swiss-terrain-dem'

export const SWISS_TERRAIN_DEM_TILES =
  'https://storage.googleapis.com/popetyio-terrain-ch/terrain-ortho/{z}/{x}/{y}.png?v=8'
